//@flow
const allowedQueries = {
  max: 'max-width',
  min: 'min-width',
};

type QueryProps = {
  max?:number,
  min?:number,
};

export default {
  toEm(opts:QueryProps = {}) {
    const queries = Object.keys(opts).filter(key => !!allowedQueries[key]).map(key => {
      return `(${allowedQueries[key]}: ${(opts[key] || 0) / 16}em)`;
    });
    return queries.join(' and ');
  },
};
